module.exports = __webpack_public_path__ + "static/media/0177_Small.49dea986.jpg";